// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__+m-tu","formInput":"Login_formInput__JRfyG","submitButton":"Login_submitButton__bHKBU"};